import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SignupService } from 'src/app/services/signup.service';

@Component({
  selector: 'dialog-print-invoice-label-dialog',
  templateUrl: 'b2b-pickup-details-dialog.html',
  styleUrls: ['b2b-pickup-details-dialog.css'],
})
export class B2BArrangePickupDetailsDialog implements OnDestroy, OnInit {
  shipmentData: any = {};
  userId: string = '';
  addresses: any[] = [];
  pickupAddress: any = {};
  pickupDisplayDateTime: any = {date: '', hours: ''};
  pickupDisplayDateTimeFEnd: any = {date: '', hours: ''};

  constructor(
    private signUpService: SignupService,
    public dialogRef: MatDialogRef<B2BArrangePickupDetailsDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  ngOnInit(): void {
    this.shipmentData = this.data.shipment;
    this.userId = this.shipmentData.b2b_user_id;
    this.addresses = this.data.addresses;

    this.addresses.find((address) => {
      if (address.id == this.shipmentData.pick_up.address_id) {
        this.pickupAddress = address;
        
      }
    });

    this.pickupDisplayDateTime = this.formatDateAndTime(this.shipmentData.pick_up.start_time);
    this.pickupDisplayDateTimeFEnd = this.formatDateAndTime(this.shipmentData.pick_up.end_time);




  }
  close(): void {
    this.dialogRef.close();
  }
  ngOnDestroy(): void {
    this.shipmentData = {};
  }

  formatDateAndTime(dateTime: string): { date: string, hours: string } {
    const [datePart, timePart] = dateTime.split(' ');
    const [year, month, day] = datePart.split('-').map(Number);
    const formattedDate = `${day.toString().padStart(2, '0')}.${month.toString().padStart(2, '0')}.${year}`;

    return {
        date: formattedDate,
        hours: timePart
    };
}
}
